import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { doc, setDoc } from "firebase/firestore";
import { db, firestorePathId } from './firebase';

// A função agora recebe o objeto user completo do AuthContext
const requestNotificationPermissionAndSaveToken = async (user) => {
  try {
    // Verifica se a API de Notificação é suportada
    if (!("Notification" in window)) {
      console.warn("Este navegador não suporta a API de Notificação.");
      return;
    }
    
    // Assegura que o user object e o UID estão disponíveis
    if (!user || !user.uid) {
        console.warn("Usuário não autenticado. Não é possível solicitar permissões de notificação.");
        return;
    }

    // Solicita a permissão do usuário para receber notificações
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Permissão para notificação negada.");
      return;
    }
    // console.log("Permissão para notificação concedida.");

    const messaging = getMessaging();

    // Obtém o token de registro do Firebase Cloud Messaging (FCM).
    const fcmToken = await getToken(messaging, {
      vapidKey: "BHKCnHRrlw2Ojo_F113jJqcgeC0H6J5WE33xG6c_VLJctl3plvNskkKJIYRxwOO7ccJ11oUMsXx9VwlA9OooXrE",
    });

    if (fcmToken) {
      // console.log("FCM Token recebido:", fcmToken);
      
      // Ajuste: Salva o token na nova localização segura
      // O nome do documento será o próprio token para evitar duplicação
      const tokenRef = doc(db, `artifacts/${firestorePathId}/users/${user.uid}/fcmTokens/${fcmToken}`);
      
      // Adiciona o uid do usuário para verificação nas regras de segurança
      await setDoc(tokenRef, { token: fcmToken, uid: user.uid, timestamp: new Date() }, { merge: true });
      // console.log("FCM Token salvo no Firestore.");
    } else {
      console.warn("Nenhum FCM Token de registro disponível. Permissão negada ou token não gerado.");
    }
  } catch (error) {
    console.error("Erro ao solicitar permissão de notificação ou salvar o token:", error);
    if (error.code === 'messaging/unsupported-browser') {
      console.error("O ambiente atual não suporta o Firebase Cloud Messaging.");
    }
  }
};

// Lida com mensagens em primeiro plano (quando a aplicação está aberta)
onMessage(getMessaging(), (payload) => {
  // console.log("Mensagem recebida em primeiro plano:", payload);
  // Exibe a notificação como um alerta ou toast, já que o navegador não a exibe automaticamente em primeiro plano
  const { title, body } = payload.notification;
  new Notification(title, { body });
});

export { requestNotificationPermissionAndSaveToken };